<h3 class="title configurator-title">{{ 'decking-boards.finishes.title' | translate }}</h3>

<div class="config-container shadow">
  <!-- Matériaux de la terrasse -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    {{ 'decking-boards.finishes.terrace-materials' | translate }}
  </h4>
  <div class="collapse-block" *ngIf="subStep === 1">
    <div class="configurator-cards-container blocked-size">
      <div
        class="configurator-card"
        [ngClass]="{
          active: isDeckingBoardTypeSelected(deckingBoardType.id),
          disabled: !hasTypeActiveBoards(deckingBoardType.id),
        }"
        *ngFor="let deckingBoardType of deckingBoardTypes"
        (click)="selectDeckingBoardType(deckingBoardType)">
        <img
          [src]="baseImgURL + deckingBoardType.icon.path"
          alt="decking-board-type-img"
          class="configurator-card-img" />
        <p class="configurator-card-title">
          {{ deckingBoardType.nameFr }}
          <a class="casto-tooltip" *ngIf="!hasTypeActiveBoards(deckingBoardType.id)" [tooltip]="unvailableBoards">?</a>
        </p>
      </div>
      <ng-casto-loader *ngIf="deckingBoardTypes === undefined"></ng-casto-loader>
    </div>
  </div>
</div>

<div class="config-container shadow mt-4">
  <!-- Teintes et Finitions -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 2,
      disabled: configuration.deckingBoardType == null,
    }"
    (click)="toggleCollapse(2)">
    {{ 'decking-boards.finishes.colors-finishes' | translate }}
    <span class="info" *ngIf="isWoodSelected(configuration.deckingBoardType)" (click)="getInfos('class')">?</span>
    <span
      class="disabled-product pt-1 ml-4"
      *ngIf="!configuration.hasValidQuotation && configuration?.deckingBoard?.isDisabled">
      {{ 'decking-boards.finishes.disable-message' | translate }}
    </span>
    <span
      class="disabled-with-quotation-product pt-1 ml-4"
      *ngIf="configuration.hasValidQuotation && configuration?.deckingBoard?.isDisabled">
      {{ 'decking-boards.finishes.valid-quotation-message' | translate }}
    </span>
    <span class="additional-info float-right mr-4 text-primary" *ngIf="configuration.deckingBoardType !== null">
      {{ countDeckingBoards(configuration.deckingBoardType?.id) }}
      {{ 'decking-boards.finishes.finishes-to-choose-from' | translate }}
    </span>
  </h4>
  <div class="collapse-block" *ngIf="subStep === 2">
    <div class="configurator-cards-container blocked-size">
      <div
        class="configurator-card"
        [ngClass]="{
          active: isDeckingBoardSelected(deckingBoard.id),
          disabled: deckingBoard.isDisabled,
        }"
        *ngFor="let deckingBoard of getDeckingBoards(configuration.deckingBoardType?.id)"
        (click)="selectDeckingBoard(deckingBoard)">
        <img [src]="baseImgURL + deckingBoard.ean.icon" alt="decking-board-img" class="configurator-card-img" />
        <!-- Fr -->
        <p class="configurator-card-title decking-board-text">
          {{ deckingBoard.ean.nameFr }}
          <span *ngIf="deckingBoard.class">{{ deckingBoard.class }}</span>
          <a
            class="casto-tooltip"
            *ngIf="deckingBoard.ean.toolTip != null"
            [tooltip]="deckingBoard.ean.toolTip?.descriptionFr"
            >?</a
          >
        </p>
      </div>
      <ng-casto-loader *ngIf="deckingBoards === undefined"></ng-casto-loader>
    </div>
  </div>
</div>

<!-- Zone de gestion des finitions supprimé le 05/04/23: TODO retirer définitivement plus tard ? -->
<!-- <div class="config-container shadow mt-4" *ngIf="hasFinishings()">
    - Type de finitions
    <h4 class="title configurator-subtitle collapse-button"
        [ngClass]="{
            active: subStep === 3,
            disabled: configuration.deckingBoardType == null || !displayDeckingBoardFinishingTypes()
        }"
        (click)="toggleCollapse(3)">
        {{ 'decking-boards.finishes.finishing-types' | translate }}
    </h4>
    <div class="collapse-block" *ngIf="subStep === 3">
        <div class="configurator-cards-container blocked-size">
            <div class="configurator-card"
                 [ngClass]="{'active': isDeckingBoardFinishingTypeSelected(deckingBoardFinishingType.id)}"
                 *ngFor="let deckingBoardFinishingType of getDeckingBoardFinishingTypes()"
                 (click)="selectDeckingBoardFinishingType(deckingBoardFinishingType)">
                <img [src]="baseImgURL + deckingBoardFinishingType.icon.path" alt="decking-board-img" class="configurator-card-img">
                <p class="configurator-card-title">{{deckingBoardFinishingType.nameFr}}</p>
            </div>
            <ng-casto-loader *ngIf="deckingBoards === undefined"></ng-casto-loader>
        </div>

         Choix de finitions 
        <h4 class="title configurator-cards-container-title"
            *ngIf="configuration.deckingBoardFinishingType !== null && countDeckingBoardFinishings(configuration.deckingBoardFinishingType?.id, configuration.deckingBoard?.id) > 0">
            {{ countDeckingBoardFinishings(configuration.deckingBoardFinishingType?.id, configuration.deckingBoard?.id) }} {{ 'decking-boards.finishes.to-choose' | translate }}
        </h4>
        <div class="configurator-cards-container blocked-size"
             *ngIf="configuration.deckingBoardFinishingType !== null && countDeckingBoardFinishings(configuration.deckingBoardFinishingType?.id, configuration.deckingBoard?.id) > 0">
            <div class="configurator-card"
                 [ngClass]="{'active': isDeckingBoardFinishingSelected(deckingBoardFinishing.id)}"
                 *ngFor="let deckingBoardFinishing of getDeckingBoardFinishings(configuration.deckingBoardFinishingType.id, configuration.deckingBoard.id)"
                 (click)="selectDeckingBoardFinishing(deckingBoardFinishing)">
                <img [src]="baseImgURL + deckingBoardFinishing.ean.icon" alt="decking-board-img" class="configurator-card-img">
                <p class="configurator-card-title">{{deckingBoardFinishing.ean.nameFr}}</p>
            </div>
            <ng-casto-loader *ngIf="deckingBoards === undefined"></ng-casto-loader>
        </div>
    </div>
</div> -->

<div class="config-container shadow mt-4">
  <!-- Lambourdes et fixations -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 3,
      disabled: !isDeckingBoardValid(),
    }"
    (click)="toggleCollapse(3)">
    {{ 'decking-boards.finishes.joists' | translate }}
    <span
      class="disabled-product pt-1 ml-4"
      *ngIf="!configuration.hasValidQuotation && configuration?.joist?.isDisabled">
      {{ 'decking-boards.finishes.disable-message' | translate }}
    </span>
    <span
      class="disabled-with-quotation-product pt-1 ml-4"
      *ngIf="configuration.hasValidQuotation && configuration?.joist?.isDisabled">
      {{ 'decking-boards.finishes.valid-quotation-message' | translate }}
    </span>
  </h4>
  <div class="collapse-block" *ngIf="subStep === 3">
    <div class="configurator-cards-container blocked-size">
      <div
        class="configurator-card"
        [ngClass]="{ active: isJoistSelected(joist.id) }"
        *ngFor="let joist of getJoists(configuration?.deckingBoard?.id)"
        (click)="selectJoist(joist)">
        <img [src]="baseImgURL + joist.ean.icon" alt="decking-board-img" class="configurator-card-img" />
        <p class="configurator-card-title decking-board-text">{{ joist.ean.nameFr }}</p>
        <p class="configurator-card-title decking-board-text" *ngIf="joist.class">{{ joist.class }}</p>
      </div>
      <ng-casto-loader *ngIf="joists === undefined"></ng-casto-loader>
    </div>
  </div>
</div>

<div class="config-container shadow mt-4">
  <!-- Lambourdes et fixations -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 4,
      disabled: !isJoistValid(),
    }"
    (click)="toggleCollapse(4)">
    {{ 'decking-boards.finishes.fixation-groups' | translate }}
  </h4>
  <div class="collapse-block" *ngIf="subStep === 4">
    <div class="configurator-cards-container blocked-size">
      <div
        class="configurator-card"
        [ngClass]="{ active: isFixationGroupSelected(fixationGroup.id) }"
        *ngFor="let fixationGroup of getFixationGroups(configuration?.deckingBoard?.id, configuration?.joist?.id)"
        (click)="selectFixationGroup(fixationGroup)">
        <img [src]="baseImgURL + fixationGroup.icon.path" alt="decking-board-img" class="configurator-card-img" />
        <p class="configurator-card-title decking-board-text">{{ fixationGroup.name_Fr }}</p>
      </div>
      <ng-casto-loader *ngIf="fixationGroups === undefined"></ng-casto-loader>
    </div>
  </div>
</div>
